import { render, staticRenderFns } from "./ModalCliente.vue?vue&type=template&id=2eba8bf8&scoped=true"
import script from "./ModalCliente.vue?vue&type=script&lang=js"
export * from "./ModalCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eba8bf8",
  null
  
)

export default component.exports